import { currentUser } from "@/App";
import { updateUser } from "@/services/api";
import { compressImage } from "@/utils/image";

const API_BASE = process.env.REACT_APP_API_BASE;

export const uploadFile = async (file) => {
  const endpoint = new URL(API_BASE + "/signed-upload");
  const response = await fetch(endpoint, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${currentUser?.token}`,
    },
  });
  const data = await response.json();
  console.log("data", data);
  const { upload_url: uploadURL, public_url: publicURL } = data;

  if (!uploadURL || !publicURL) {
    throw new Error("Invalid response from signed URL endpoint");
  }

  // Upload file to signed URL
  const uploadResponse = await fetch(uploadURL, {
    headers: {
      "Content-Type": file.type,
    },
    method: "PUT",
    body: file,
  });

  if (!uploadResponse.ok) {
    throw new Error(`Failed to upload file: ${uploadResponse.statusText}`);
  }

  return publicURL;
};

export const uploadImage = async (file) => {
  const compressedFile = await compressImage(file);

  const endpoint = new URL(API_BASE + "/signed-upload");
  const response = await fetch(endpoint, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${currentUser?.token}`,
    },
  });
  const data = await response.json();
  // console.log("data", data);
  const { upload_url: uploadURL, public_url: publicURL } = data;

  if (!uploadURL || !publicURL) {
    throw new Error("Invalid response from signed URL endpoint");
  }

  // Upload file to signed URL
  const uploadResponse = await fetch(uploadURL, {
    headers: {
      "Content-Type": compressedFile.type,
    },
    method: "PUT",
    body: compressedFile,
  });

  if (!uploadResponse.ok) {
    throw new Error(`Failed to upload file: ${uploadResponse.statusText}`);
  }

  return publicURL;
};

export const uploadUserFile = async (file, type) => {
  try {
    const endpoint = new URL(API_BASE + "/signed-upload");
    const response = await fetch(endpoint, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${currentUser?.token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to get signed URL: ${response.statusText}`);
    }

    const data = await response.json();
    const { upload_url: uploadURL, public_url: publicURL } = data;

    if (!uploadURL || !publicURL) {
      throw new Error("Invalid response from signed URL endpoint");
    }

    // Upload file to signed URL
    const uploadResponse = await fetch(uploadURL, {
      headers: {
        "Content-Type": file.type,
      },
      method: "PUT",
      body: file,
    });

    if (!uploadResponse.ok) {
      throw new Error(`Failed to upload file: ${uploadResponse.statusText}`);
    }

    // Update user metadata with the new URL
    await updateUser(null, { [type]: publicURL });
    return publicURL;
  } catch (error) {
    console.error("Error uploading file:", error);
    throw error;
  }
};
